import {TypeUtils} from "../../shared/utils/type-utils";
import {
  KnowledgeBaseAction,
  LOAD_KNOWLEDGE_BASE,
  TOGGLE_KNOWLEDGE_BASE,
  ToggleKnowledgeBase
} from "../actions/knowledge-base.action";


export interface IWebsiteActivitiesState {
  websiteId: number,
  entities: {[activityId: string]: any}
}

export interface IKnowledgeBaseState {
  entities: {[websiteId: number]: IWebsiteActivitiesState},
  loading: boolean,
  loaded: boolean,
  toggled: boolean,
  activeTab: string
}

export const initialState: any = {
  entities: {},
  loading: false,
  loaded: false,
  toggled: false,
  activeTab: 'knowledge-base'
};

export function reducer(state: any = initialState, action: KnowledgeBaseAction): any {

  switch (action.type) {

    case LOAD_KNOWLEDGE_BASE:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case TOGGLE_KNOWLEDGE_BASE:
      let toggled: boolean = (<ToggleKnowledgeBase>action).payload;
      if (TypeUtils.isUndefined(toggled)) {
        toggled = !state.toggled;
      }

      return {
        ...state,
        toggled: toggled
      };

  }

  return state;
}
